import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/redesign-temp/girl-s4-p1.svg")